<template>
  <div class="home-search" :class="[deviceType]">
    <div class="search-header">
      <router-link to="/names" class="search-title-link">
        <div class="search-title">Search by Filter</div>
      </router-link>
    </div>
    <div class="search-content">
      <SearchFilter />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SearchFilter from '@/components/SearchFilter.vue';

export default {
  name: 'HomeSearch',
  components: {
    SearchFilter
  },
  computed: {
    ...mapGetters([
      'deviceType'
    ]),
  }
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.home-search {
	padding: rem(60) 0;
	display: flex;
	flex-direction: column;
	gap: rem(24);
	align-items: flex-start;
	justify-content: flex-start;
	position: relative;

	.search-header {
		padding: 0 rem(180);
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		position: relative;

		.search-title-link {
			text-decoration: none;
			cursor: pointer;
		}

		.search-dot {
			background: #a31984;
			border-radius: rem(100);
			width: rem(8);
			height: rem(4);
			position: relative;
		}

		.search-title {
			color: #fff;
			text-align: left;
			font-size: rem(28);
			line-height: rem(28);
			font-weight: 900;
			position: relative;
		}
	}

	.detect_deviece_mobile & {
		padding: rem(60) 0;

		.search-header {
			padding: 0 rem(16);
		}
	}

	.search-content {
		padding: 0 rem(180);
		display: flex;
		flex-direction: column;
		gap: rem(10);
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		position: relative;
	}

	&.mobile {
		.search-content {
			padding: 0 rem(16);
		}
	}
}
</style>